import { createFileRoute } from '@tanstack/react-router'

import { PlatformAnnouncementsPage } from '../../../components/pages/backoffice/platform/platform-announcements-page/platform-announcements-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/announcements/')({
  component: () => (
    <PermissionChecker requiredPermissions={['backofficeAnnouncement.read']}>
      <PlatformAnnouncementsPage />
    </PermissionChecker>
  ),
})
